import { render, staticRenderFns } from "./ShareTag.vue?vue&type=template&id=4ab42fc2&"
import script from "./ShareTag.vue?vue&type=script&lang=js&"
export * from "./ShareTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports